import { AuthProvider } from './auth/AuthContext';
import { BackendProvider } from './backend/BackendContext';
import type { Backend } from './backend/backend';
import { AppRouter } from './app-router';

/** `backend` is only passed by tests; the app runs on the local backend until T074a. */
export function App({ backend }: { backend?: Backend }) {
  return (
    <BackendProvider {...(backend !== undefined ? { backend } : {})}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BackendProvider>
  );
}
